module.exports = __webpack_public_path__ + "img/drt4.909eb102.png";